import Layout from "../components/Layout";
import About from "../components/About";

const AboutScreen = () => {
  return (
    <Layout>
      <About />
    </Layout>
  );
};

export default AboutScreen;